import { render, staticRenderFns } from "./Customers.edit.vue?vue&type=template&id=ac7131ec&"
import script from "./Customers.edit.vue?vue&type=script&lang=js&"
export * from "./Customers.edit.vue?vue&type=script&lang=js&"
import style0 from "./Customers.edit.vue?vue&type=style&index=0&id=ac7131ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports